import React from "react";
import HeroImage from "../assets/hero Image2.png";
import { motion } from "framer-motion";

const HeroSection = () => {
  return (
    <motion.section
      id="home"
      className="relative container m-auto flex items-center px-4 md:px-0"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <div className=" py-12 md:py-0 flex flex-col justify-between md:flex-row md:justify-start items-center">
        {/* Image */}
        <motion.div
          className="md:absolute md:bottom-0 md:right-0 w-full md:w-[45%]"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8, ease: "easeInOut" }}
        >
          <img
            src={HeroImage}
            alt="Personalof Abdalbaset"
            className="object-cover"
          />
        </motion.div>

        {/* Textese */}
        <div className="flex flex-col gap-y-12 md:mt-20">
          <motion.div
            className="flex flex-col gap-y-9"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: "easeInOut" }}
          >
            <h1 className="text-3xl tracking-wide md:text-[72px] font-bold text-white text-opacity-95">
              HI I’m Abdalbaset
            </h1>
            <p className="text-lg tracking-wide md:text-[32px] font-normal text-white text-opacity-80">
              UI/UX Design & Front-end Developer
            </p>
          </motion.div>
          {/* Bottons*/}
          <motion.div
            className="flex-row md:flex items-center gap-4 md:gap-10"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeInOut" }}
          >
            <a
              href="https://drive.google.com/uc?export=download&id=1DeW7kdlASgtn3zD7uik_atVJNAuiHKPa"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center w-full md:w-fit mb-6 md:mb-0 py-4 px-8 bg-primary_800 rounded-lg text-2xl font-semibold hover:bg-primary_700 transition duration-300"
            >
              My Resume
            </a>
            <a
              className="block text-center mt-4 md:mt-0 w-full md:w-fit py-4 px-8 border border-white border-opacity-20 text-white text-opacity-80 rounded-lg text-2xl font-semibold hover:bg-white_300 hover:text-black transition-all duration-400"
              href="#contact"
            >
              Get in touch
            </a>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default HeroSection;
